import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import moment from "moment";
import { Menu, MenuItem } from "@mui/material";
import { Button, Form, Modal } from "react-bootstrap";
import TaskApi from "../../api/TaskApi";
import building from "../../images/building.png";
import equipment from "../../images/equipment.png";
import Vechiles from "../../images/Vechiles.png";
import DoneIcon from "@mui/icons-material/Done";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AuthService from "../../session/AuthService";

class TaskGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      selectedEditData: {},
      opendeleteproductDialogue: false,
      openTaskCompleteDialogue: false,
      note: "",
    };
  }

  render() {
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Employee</th>
                  <th>Task Name</th>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.props.taskList.map((e) => (
                  <tr>
                    <td className="avatar-cell">
                      <div className="avatar">
                        <Avatar>
                          {e && e.employeeid !== 0
                            ? (e.firstName &&
                                e.firstName.charAt(0).toUpperCase()) ||
                              ""
                            : "A"}
                        </Avatar>
                        <div className="name">
                          {e && e.employeeid !== 0
                            ? (e.firstName &&
                                e.firstName.charAt(0).toUpperCase() +
                                  e.firstName.slice(1)) ||
                              ""
                            : "All"}
                        </div>
                      </div>
                    </td>

                    <td>{e.taskName}</td>
                    <td>{moment(e.updatedDate).format("dddd, D MMMM YYYY")}</td>
                    <td>
                      {e.resourseType === 1 ? (
                        <img
                          src={building}
                          alt="Builiding"
                          style={{ width: "2rem" }}
                          loading="lazy"
                        />
                      ) : e.resourseType === 2 ? (
                        <img
                          src={equipment}
                          alt="equipment"
                          style={{ width: "2rem" }}
                          loading="lazy"
                        />
                      ) : e.resourseType === 3 ? (
                        <img
                          src={Vechiles}
                          alt="Vechiles"
                          style={{ width: "2rem" }}
                          loading="lazy"
                        />
                      ) : (
                        <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>
                      )}
                    </td>
                    <td>{e.taskstatus}</td>
                    <td>
                      {
                        <>
                          <MoreHorizIcon
                            onClick={(event) =>
                              this.handleFilterClick(event, e)
                            }
                          />{" "}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleFilterClose2}
                            className="exclude-menu"
                          >
                            {AuthService.getUserTypeAdmin() !== "3" &&
                              e.taskstatus !== "Complete" && (
                                <MenuItem
                                  onClick={(e) =>
                                    this.handleFilterClose("taskcomplete", e)
                                  }
                                >
                                  <DoneIcon />{" "}
                                  <span className="inisde-the-action">
                                    Complete Task
                                  </span>
                                </MenuItem>
                              )}

                            <MenuItem
                              onClick={(e) => this.handleFilterClose("edit", e)}
                            >
                              <EditOutlinedIcon />{" "}
                              <span className="inisde-the-action">Edit</span>
                            </MenuItem>
                            {AuthService.getUserTypeAdmin() !== "3" && (
                              <>
                                <MenuItem
                                  onClick={() =>
                                    this.handleFilterClose("delete")
                                  }
                                >
                                  <DeleteOutlinedIcon />{" "}
                                  <span className="inisde-the-action">
                                    Delete
                                  </span>
                                </MenuItem>
                              </>
                            )}
                          </Menu>
                        </>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.taskList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        {this.state.openTaskCompleteDialogue && this.taskCompletedialoug()}
      </>
    );
  }

  handleFilterClick = (event, data) => {
    console.log("event", event, data);
    this.props.openCompleteButtonMethod();
    this.setState(
      {
        anchorEl: event.target,
        selectedEditData: data,
      },
      () => {
        console.log("selectedEditData", this.state.selectedEditData);
      }
    );
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState) => {
    console.log("e", getState.note);
    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    } else if (getState === "taskcomplete") {
      if (this.state.selectedEditData.allowServiceRecord === true) {
        this.setState(
          {
            openTaskCompleteDialogue: true,
            anchorEl: null,
            note: this.state.selectedEditData.note,
          },
          () => {}
        );
      } else {
        this.setState(
          {
            anchorEl: null,
            note: this.state.selectedEditData.note,
          },
          () => {
            this.completeTask();
          }
        );
      }
    }
  };

  handleClose = () => {
    this.setState({ opendeleteproductDialogue: false });
  };

  closeTaskComplete = () => {
    this.setState({ openTaskCompleteDialogue: false });
  };

  deleteTask = () => {
    let obj = {
      taskId: this.state.selectedEditData.taskId,
    };

    TaskApi.deleteTask(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.completeTaskOnLoad();
      }
    });
  };

  onNoteChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  completeTask = () => {
    const { selectedEditData } = this.state;

    selectedEditData.note = this.state.note;

    TaskApi.updateTask(selectedEditData).then((response) => {
      if (response.data && response.data.message === "Success") {
        this.closeTaskComplete();
        this.props.completeTaskOnLoad();
        this.props.renderToast("Complete");
      }
    });
  };

  openServiceRecord = () => {
    this.props.openService(this.state.selectedEditData);
  };

  deleteproductPopUp = () => {
    return (
      <Modal show={true} size="md" centered onHide={this.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete Task</h3>
        </Modal.Header>

        <Modal.Body className="">
          <div className="basicInfoWrapper newServiceFormWrapper">
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Are you sure to delete this Task</Form.Label>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer className="CNSFooter">
          <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
          <Button variant="success" type="button" onClick={this.deleteTask}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  taskCompletedialoug = () => {
    return (
      <Modal show={true} size="md" centered onHide={this.closeTaskComplete}>
        <Modal.Header closeButton className="CNSHeader">
          <h6 style={{ fontWeight: "bolder" }}>Complete Task </h6>
        </Modal.Header>

        {/* <Modal.Body className="">
          <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
            <Form.Label>Add Note</Form.Label>
            <textarea
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              name="note"
              value={this.state.note}
              onChange={this.onNoteChange}
            ></textarea>
          </Form.Group>
        </Modal.Body> */}
        <Modal.Footer className="CNSFooter">
          <Button variant="secondary" onClick={this.closeTaskComplete}>
            Cancel
          </Button>
          {this.state.selectedEditData.allowServiceRecord &&
            this.state.selectedEditData.resourseType !== 4 && (
              <>
                <Button variant="success" onClick={this.openServiceRecord}>
                  Add Service Record
                </Button>
              </>
            )}

          {(this.state.selectedEditData.allowCompleteButton ||
            this.state.selectedEditData.resourseType === 4 ||
            this.props.openCompleteButton) && (
            <>
              <Button
                variant="success"
                type="button"
                onClick={this.completeTask}
              >
                Complete Task
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  };
}
export default TaskGrid;
